<template>
  <div class="app-container activity-detail">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="detail">
          <div class="operation">
            <el-button size="small" type="primary" @click="$router.push({ path: `/app/activity/edit/${id}` })" 
              v-if="permissions.activity_edit">编辑培训</el-button>
            <el-button size="small" type="primary" @click="openPublishDialog()" 
              v-if="permissions.activity_publish && activityDetail.status == activityStatus.CREATED">上架培训</el-button>
            <!-- <el-button size="small" type="primary" @click="openSendMassMessageDialog(true)" 
              v-if="activityDetail.status != activityStatus.CREATED">群发短信</el-button> -->
            <el-button size="small" type="primary" @click="openPullOffDialog"
              v-if="permissions.activity_publish && activityDetail.status != activityStatus.CREATED">下架培训</el-button>
          </div>
          <el-row class="activity-detail-item" >
            <el-col :span="4">培训列表页图片:</el-col>
            <el-col :span="16">
              <div class="activity-list-page-image" v-if="activityDetail.listPageImage">
                <img :src="activityDetail.listPageImage" v-viewer class="activity-image">
              </div>
            </el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4">培训名称:</el-col>
            <el-col :span="16">{{activityDetail.name}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4">培训名称（英文）:</el-col>
            <el-col :span="16">{{activityDetail.nameEn}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4" >培训地点:</el-col>
            <el-col :span="16">{{activityDetail.place}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4" >培训地点（英文）:</el-col>
            <el-col :span="16">{{activityDetail.placeEn}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4" >课程类别:</el-col>
            <el-col :span="16">{{activityDetail.category}}</el-col>
          </el-row>
          <!-- <el-row class="activity-detail-item">
            <el-col :span="4">培训类型:</el-col>
            <el-col :span="16">{{ activityDetail.type }}</el-col>
          </el-row> -->
          <el-row class="activity-detail-item">
            <el-col :span="4" >培训时间:</el-col>
            <el-col :span="16">{{(activityDetail.startTime &&activityDetail.endTime) ? dateFormat(activityDetail.startTime) + ' - ' + dateFormat(activityDetail.endTime) : ''}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4">是否只显示日期:</el-col>
            <el-col :span="16">{{activityDetail.isOnlyShowDate ? '是' : '否'}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
             <el-col :span="4">报名截止时间:</el-col>
            <el-col :span="16">{{activityDetail.joinEndTime}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4">"取消报名"截止时间:</el-col>
            <el-col :span="16">{{activityDetail.showBeforeProject?activityDetail.showBeforeProject:dateFormat(activityDetail.cancelJoinEndTime)}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4" >培训状态:</el-col>
            <el-col :span="16">{{ activityDetail.statusDesc }}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4" >报名范围:</el-col>
            <el-col :span="16">{{activityDetail.isPublic ? '所有人' : activityDetail.scopeTags.map(item => item.tagName).join(',')}}</el-col>
          </el-row>
           <!-- <el-row class="activity-detail-item">
            <el-col :span="4" >培训报名二维码:</el-col>
            <el-col :span="16"><div class="can-click-item" @click="openQrCodeDialog(activityDetail.activityUrl, '培训报名二维码')">获取二维码</div></el-col>
          </el-row> -->
          <el-row class="activity-detail-item">
            <el-col :span="4" >创建人:</el-col>
            <el-col :span="16">{{activityDetail.insertedByName}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4" >创建时间:</el-col>
            <el-col :span="16">{{activityDetail.insertedTime}}</el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4" >培训内容:</el-col>
            <el-col :span="16" v-html="activityDetail.content"></el-col>
          </el-row>
          <el-row class="activity-detail-item">
            <el-col :span="4" >培训内容（英文）:</el-col>
            <el-col :span="16" v-html="activityDetail.contentEn"></el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="培训项目列表" name="activityProject">
          <div class="operation">
            <el-button size="small" type="primary" @click="toEditProjectGroup"
              v-if="permissions.activity_edit">编辑培训</el-button>
            <el-button size="small" type="primary" @click="openPublishDialog()" 
              v-if="permissions.activity_publish && activityDetail.status == activityStatus.CREATED">上架培训</el-button>
            <!-- <el-button size="small" type="primary" @click="openSendMassMessageDialog(true)" 
              v-if="activityDetail.status != activityStatus.CREATED">群发短信</el-button> -->
            <el-button size="small" type="primary" @click="openPullOffDialog"
              v-if="permissions.activity_publish && activityDetail.status != activityStatus.CREATED">下架培训</el-button>
          </div>
          <el-card>
            <el-row class="activity-detail-item">
              <el-col :span="4" >是否显示项目容纳人数:</el-col>
              <el-col :span="16">{{activityDetail.showCapacity ? '是' : '否' }}</el-col>
            </el-row>
            <el-row class="activity-detail-item">
              <el-col :span="4" >是否显示项目剩余名额:</el-col>
              <el-col :span="16">{{activityDetail.showRemainingPlaces ? '是' : '否'}}</el-col>
            </el-row>
            <el-row class="activity-detail-item">
              <el-col :span="4" >培训项目数量:</el-col>
              <el-col :span="16">{{activityDetail.multipleProjectsMode ? '多项' : '单项'}}</el-col>
            </el-row>
            <el-row class="activity-detail-item">
              <el-col :span="4" >培训项目选择模式:</el-col>
              <el-col :span="16">{{activityDetail.multipleProjectsChoseMode ? '多项' : '单项'}}</el-col>
            </el-row>
            <el-row class="activity-detail-item">
              <el-col :span="4" >培训项目报名总数:</el-col>
              <el-col :span="16">{{activityDetail.enrollmentCount}}</el-col>
            </el-row>
            <el-row class="activity-detail-item">
              <el-col :span="4" >是否需要报名审批:</el-col>
              <el-col :span="16">{{activityDetail.needApprove ? '是' : '否'}}</el-col>
            </el-row>
            <el-row class="activity-detail-item">
              <el-col :span="4" >是否支持排队机制:</el-col>
              <el-col :span="16">{{activityDetail.supportQueue ? '是' : '否'}}</el-col>
            </el-row>
            <el-row class="activity-detail-item" v-if="activityDetail.supportQueue">
              <el-col :span="4" >排队截止时间:</el-col>
              <el-col :span="16">{{activityDetail.queueEndBeforeProjectStartHours}}</el-col>
            </el-row>
          </el-card>
          <el-card class="box-card" v-for="(projectGroup, index) in activityDetail.projectGroups" :key="index">
            <div class="divider"></div>
            <!-- 项目组信息 -->
            <div>项目组{{ index + 1 }}： {{projectGroup.name}}（{{projectGroup.nameEn}}）</div>
            <div>{{!projectGroup.hint ? '--' : projectGroup.hint}}（{{!projectGroup.hintEn ? '--' : projectGroup.hintEn}}）（用户可报名{{parseInt(projectGroup.maxEnrollProjects) ? (projectGroup.minEnrollProjects + '-' + projectGroup.maxEnrollProjects + '项') : ('至少' + projectGroup.minEnrollProjects + '项')}}）</div>
            <!-- 此项目组下的子项目信息 -->
            <avue-crud
                ref="activityProjectsCrud"
                :option="activityProjectsTableOption"
                :data="activityDetail.activityProjectList.filter((v) => v.groupId == projectGroup.id)"
                :table-loading="tableLoading">
              <template slot="time" slot-scope="scope">
                {{ `${dateFormat(scope.row.startTime)} - ${dateFormat(scope.row.endTime)}`}}
              </template>
              <template slot="checkInTimes" slot-scope="scope">
                <div class="can-click-item" @click="handleViewProjectCheckinDateRangeList(scope.row.checkInDateRange)">{{scope.row.checkInTimes}}</div>
              </template>
              <template slot="checkinCodeUrl" slot-scope="scope">
                <div v-show="scope.row.checkInType == 2" class="can-click-item" @click="openQrCodeDialog(scope.row.checkinCodeUrl, '签到二维码')">点击下载</div>
              </template>
              <template slot="enrollmentCount" slot-scope="scope">
                <div>{{ scope.row.enrollmentCount || 0 }}</div>
              </template>
              <template slot="enrollmentSuccessCount" slot-scope="scope">
                <div>{{ scope.row.enrollmentSuccessCount || 0 }}</div>
              </template>
              <template slot="checkinMiniProgramCodeUrl" slot-scope="scope">
                <div v-show="scope.row.checkInType == 2" class="can-click-item" @click="previewCheckinMiniProgramQrcode(scope.row.id)">点击查看</div>
              </template>
              <template slot="relatedQuestionnaireId" slot-scope="scope">
                <span v-show="scope.row.relatedQuestionnaireId" class="can-click-item" @click="getQuestionnaireDetail(scope.row.relatedQuestionnaireId)">
                  {{ scope.row.relatedQuestionnaireName }}
                </span>
                <span v-show="!scope.row.relatedQuestionnaireId">--</span>
              </template>
              <template slot="menu" slot-scope="scope">
                <el-button size="mini"
                      type="text"
                      icon="el-icon-plus"
                      @click="handleInviteMember(scope.row,scope.index)">邀请</el-button>
                <el-button size="mini"
                      type="text"
                      icon="el-icon-bell"
                      @click="handleSendCourseReminder(scope.row,scope.index)">发送课程提醒</el-button>
              </template>
            </avue-crud>
          </el-card>
        </el-tab-pane>
    
        <el-tab-pane label="已报名名单" name="enrollment">
          <div class="activity-enrollment-list">
            <div class="activity-enrollment-list-filter">
              <el-row>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-select class="activity-enrollment-list-filter-value" v-model.trim="search.groupId" @change="searchChange" placeholder="项目组" clearable size="small">
                      <el-option v-for="project in activityDetail.projectGroups" :key="project.id" :label="project.name" :value="project.id"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-select class="activity-enrollment-list-filter-value" v-model.trim="search.projectId" @change="searchChange" placeholder="子项目" clearable size="small">
                        <el-option v-for="project in (search.groupId ? activityDetail.activityProjectList.filter((v) => v.groupId == search.groupId) : [])" :key="project.id" :label="project.name" :value="project.id"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-select class="activity-enrollment-list-filter-value" v-model.trim="search.tagId" @change="searchChange" placeholder="报名范围" clearable size="small">
                      <el-option v-for="tag in activityDetail.scopeTags" :key="tag.id" :label="tag.tagName" :value="tag.id"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="activity-enrollment-list-filter-value" v-model.trim="search.unionId" @keyup.enter.native="searchChange" placeholder="员工号" clearable size="small" ></el-input>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="activity-enrollment-list-filter-value" v-model.trim="search.searchValue" @keyup.enter.native="searchChange" placeholder="Birth Name或Full Name" clearable size="small" ></el-input>
                  </div>
                </el-col>
                <el-col v-show="search.status === 'APPROVED'" :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="activity-enrollment-list-filter-value" v-model.trim="search.checkInTimes" @keyup.enter.native="searchChange" placeholder="签到次数" clearable size="small"></el-input>
                  </div>
                </el-col>
                <el-col v-show="search.status === 'APPROVED'" :span="6">
                  <div class="grid-content bg-purple">
                    <el-select 
                      class="activity-enrollment-list-filter-value" 
                      ref="statusSelect" 
                      v-model="search.enrollStatus" 
                      @change="searchChange" 
                      @keydown.enter.native="$refs.statusSelect.visible = false" 
                      placeholder="报名状态" 
                      clearable 
                      size="small">
                      <el-option
                        v-for="(item, index) in employeeApplyStatusTypeOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col v-show="search.status === 'APPROVED'" :span="6">
                  <div class="grid-content bg-purple">
                    <el-select
                      class="activity-enrollment-list-filter-value" 
                      ref="auditStatusSelect" 
                      v-model="search.auditStatus" 
                      @change="searchChange" 
                      @keydown.enter.native="$refs.auditStatusSelect.visible = false" 
                      placeholder="审核状态" 
                      clearable 
                      size="small">
                      <el-option
                        v-for="(item, index) in approveStatusOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-input class="activity-enrollment-list-filter-value" v-model.trim="search.organizationalUnitName" @keyup.enter.native="searchChange" placeholder="Organizational Unit Name" clearable size="small" ></el-input>
                  </div>
                </el-col>
                <el-col :span="search.status === 'APPROVED' ? 18 : 12">
                  <div>
                    <el-button class="activity-enrollment-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
                    <el-button class="activity-enrollment-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <avue-crud ref="crud"
            :option="search.status === 'APPROVED' ? activityApprovedEnrollmentListTableOption : activityPendingEnrollmentListTableOption"
            :data="activityDetail.activityEnrollmentList"
            :page="page"
            :table-loading="tableLoading"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            @sort-change="handleSortChange"
            @selection-change="handleSelectionChange">
            <template slot="menuLeft">
              <el-button v-show="search.status === 'PENDING' && permissions.activity_enrollment_approve" type="primary" size="small" @click="handleApproveEnrollment">批准参与</el-button>
              <el-button v-show="search.status === 'PENDING' && permissions.activity_enrollment_reject" type="primary" size="small" @click="openRejectEnrollmentDialog">拒绝参与</el-button>
              <el-button type="primary" icon="el-icon-download" size="small" @click="handleEnrollmentMemberExport" :loading="memberExportLoading">{{memberExportName}}</el-button>
              <el-button v-show="search.status === 'APPROVED'" type="primary" icon="el-icon-download" size="small" @click="handleEnrollmentCheckinExport" :loading="checkinExportLoading">{{checkinExportName}}</el-button>
            </template>

            <template slot="menuRight">
              <el-radio-group v-model="search.status" size="small" @change="searchChange">
                <el-radio-button v-if="activityDetail.needApprove" label="PENDING"><i class="el-icon-warning"></i>&nbsp;未审核</el-radio-button>
                <el-radio-button label="APPROVED"><i class="el-icon-success"></i>&nbsp;已审核</el-radio-button>
              </el-radio-group>
            </template>

            <template slot-scope="scope" slot="phoneNumber">
              <sensitive-data type="phoneNumber" :rawData="scope.row.phoneNumber" :unionId="scope.row.unionId" />
            </template>

            <template slot-scope="scope" slot="checkin">
              <el-button type="text" @click="showCheckInTimeDialog(scope.row)">{{scope.row.checkin}}</el-button>
            </template>

            <template slot-scope="scope" slot="menu">
              <el-button type="text" icon="el-icon-delete" size="mini" @click="handleEnrollmentDel(scope.row.id)">删除</el-button>
              <!-- 关闭【优先排队】功能 -->
              <!-- <el-button v-if="permissions.activity_enrollment_approve && search.status === 'PENDING' && scope.row.enrollStatus === 'QUEUING'"
                type="text" icon="el-icon-check" size="mini" @click="handleEnrollmentPriorityQueuing(scope.row)">优先排队</el-button> -->
            </template>
          </avue-crud>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
    <el-dialog
      :title="qrCodeDialogTitle"
      :visible.sync="manualDialogVisible"
      width="35%"
      center>
      <template>
        <el-row>
          <div class="ju-modal-content">
            <div :class="{'option-select': qrCodeSize == 1000}" @click="changeQrCodeSize(1000)" class="size-options">
              <div class="size-content">
                <div class="size-types">大尺寸</div>
                <div class="size-value">1000x1000像素</div>
              </div>
            </div>
            <div :class="{'option-select': qrCodeSize == 500}" @click="changeQrCodeSize(500)" class="size-options">
              <div class="size-content">
                <div class="size-types">中等尺寸</div>
                <div class="size-value">500x500像素</div>
              </div>
            </div>
            <div :class="{'option-select': qrCodeSize == 300}" @click="changeQrCodeSize(300)" class="size-options">
              <div class="size-content">
                <div class="size-types">小尺寸</div>
                <div class="size-value">300x300像素</div>
              </div>
            </div>
          </div>
        </el-row>
      </template>
      
      <span slot="footer" class="dialog-footer">
       <el-row>
          <div>
            <vue-qr :text="qrCodeValue" size="300"></vue-qr>
          </div>
          <div id="activity-qr-code">
            <vue-qr :text="qrCodeValue" :size="qrCodeSize"></vue-qr>
          </div>
          <el-button @click="closeQrCodeDialog()">关闭</el-button>
          <el-button type="primary" @click="downloadQrCode()">下载</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="上架培训"
      :visible.sync="activityPublishDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">您确定要上架该培训吗？</el-row>
         <el-row class="dialog-body-row">
           <el-checkbox v-model="isActivityPublishNotice">发送短信</el-checkbox>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="activityPublishDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handlePublishActivity()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="下架培训"
      :visible.sync="activityPullOffDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">您确定要下架该培训吗？</el-row>
         <el-row class="dialog-body-row">
          <el-input type="textarea" placeholder="请输入下架该培训的原因" :rows="3" v-model="messageToPullOffActivity" :maxlength="500"></el-input>
         </el-row>
         <el-row class="dialog-body-row">
           <el-checkbox v-model="isActivityPullOffNoticeInvitedUser">发短信给受邀用户</el-checkbox>
           <el-checkbox v-model="isActivityPullOffNoticeEnrolledUser">发短信给已报名用户</el-checkbox>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="activityPullOffDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handlePullOffActivity()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="拒绝参与"
      :visible.sync="rejectEnrollmentDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">请填写拒绝原因并短信发送该消息。</el-row>
         <el-row class="dialog-body-row">
          拒绝原因:
        </el-row>
         <el-row class="dialog-body-row">
            <el-input type="textarea" :rows="3" v-if="rejectEnrollmentDialogVisible" v-model="rejectEnrollmentReason" :maxlength="512"></el-input>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="rejectEnrollmentDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleRejectEnrollment()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="群发短信"
      :visible.sync="sendMassMessageDialogVisible"
       width="45%">
       <template>
         <el-row class="dialog-body-row">
           <el-col :span="3">群发对象：</el-col>
           <!-- <el-col :span="21">{{ isToActivityAllUser ? '所有人' : Array.from(new Set(selectedEnrollmentList.map(enrollment => enrollment.tagName))) }}</el-col> -->
           <el-col :span="21">{{activityDetail.isPublic ? '所有人' : activityDetail.scopeTags.map(item => item.tagName).join(',')}}</el-col>
         </el-row>
          <el-row class="dialog-body-row">
           <el-col :span="3">群发短信：</el-col>
           <el-col :span="21">
            <!-- <el-tabs v-model="activeMassMessageType" type="card">
              <el-tab-pane name="text">
                <span slot="label"><i class="el-icon-document"></i> 文本</span>
                <el-input type="textarea" v-model="massMessageTextContent" maxlength="500" rows="6" show-word-limit/>
              </el-tab-pane>
              <el-tab-pane name="image">
                <span slot="label"><i class="el-icon-picture-outline"></i> 图片</span>
                <div v-if="massMessageImageUrl">
                  <img class="mass-message-image" :src="massMessageImageUrl | ossImageProcess">
                  <el-button type="text" @click="massMessageImageUrl = ''" icon="icon-remove-image" class="image-remove-icon"></el-button>
                </div>
                <el-button v-else type="text" @click="handleMassMessageImageChange" icon="icon-add-cover"></el-button>
              </el-tab-pane>
            </el-tabs> -->
            <el-input type="textarea" v-model="massMessageTextContent" maxlength="500" rows="6" show-word-limit/>
           </el-col>
         </el-row>
          <!-- <el-row class="dialog-body-row">
           <el-col :span="3">保密消息：</el-col>
           <el-col :span="21">
             <el-switch v-model="isSafe"/>
           </el-col>
          </el-row> -->
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="sendMassMessageDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSendMassMessage()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="删除确认"
      :visible.sync="delEnrollmentDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">提示：删除此报名记录后该用户将会被取消该培训参与资格</el-row>
         <el-row class="dialog-body-row">原因：</el-row>
         <el-row class="dialog-body-row">
            <el-input type="textarea" :rows="3" v-if="delEnrollmentDialogVisible" v-model="delEnrollmentReason" :maxlength="512"></el-input>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="delEnrollmentDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelEnrollment()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="删除确认"
      :visible.sync="delProjectDialogVisible"
       width="35%">
       <template>
         <el-row class="dialog-body-row">提示：请填写删除原因并短信发送该消息至已报名员工。</el-row>
         <el-row class="dialog-body-row">原因：</el-row>
         <el-row class="dialog-body-row">
            <el-input type="textarea" :rows="3" v-if="delProjectDialogVisible" v-model="delProjectReason" :maxlength="512"></el-input>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="delProjectDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleDelProject()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="签到时间列表"
      :visible.sync="checkInTimeDialogVisible"
       width="35%">
       <div v-if="currentCheckinTimeList.length">
        <div v-for="(item, index) in currentCheckinTimeList" :key="index">
          第{{ index + 1}}次签到时间： {{item}}
        </div>
       </div>
       <div v-else>
         暂无签到时间记录
       </div>
        <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="checkInTimeDialogVisible = false">取消</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="签到时间列表"
      :visible.sync="checkInDateRangeDialogVisible"
      width="30%"
      @close="handleCheckInDateRangeDialogClose">
        <div v-for="(item, index) in currentCheckInDateRangList" :key="index" class="checkin-daterange-dialog-item">
          {{`第${index + 1}次签到时间：${dateFormat(item.startTime)} - ${dateFormat(item.endTime)}`}}
        </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="projectCheckinMiniprogramQrcodeDialogVisible"
      fullscreen
      custom-class="preview-img-dialog"
      @closed="projectCheckinMiniProgramQrcodeUrl=''">
      <div @click="projectCheckinMiniprogramQrcodeDialogVisible = false">
        <img :src="projectCheckinMiniProgramQrcodeUrl" width="430" />
      </div>
    </el-dialog>
    <el-dialog
      title="邀请用户"
      :visible.sync="inviteMemberDialogVisible"
      width="30%">
      <template>
        <div>
          <el-label class="edit-dialog-item-label">项目名称</el-label>
          <el-input v-model="inviteMemberProjectName" disabled />
        </div>
        <div>
          <el-label class="edit-dialog-item-label">请输入员工号</el-label>
          <el-input
            clearable
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入员工号，多个员工号请用英文逗号’,‘分隔"
            v-model="inviteMemberUnionIds">
          </el-input>
          <div class="tip">多个员工号请用英文逗号’,‘分隔</div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelInviteMember()">取 消</el-button>
        <el-button type="primary" @click="handleConfirmInviteMember()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from 'vue-qr';
import { mapGetters } from "vuex";
import { formatDate } from '@/util/date';
import { exporting } from '@/util/exportUtil';
import { fetchDepartmentOptions } from '@/api/admin/dept';
import { activityApprovedEnrollmentListTableOption, activityPendingEnrollmentListTableOption, supportQueueActivityProjectsTableOption, activityProjectsTableOption, activityStatus, statusTypeOptions, approveStatusOptions, employeeApplyStatusTypeOptions } from '@/const/crud/app/activity';
import Api from '@/api/app/activity';
import SensitiveData from '@/components/sensitive-data';

const initDetail = vm => {
  Api.getActivity(vm.id).then(({data}) => {
    if (data.code === 0) {
      formatActivityBaseDetail(vm, vm.activityDetail, data.data);
    } else {
      this.$message.error(data.msg);
    }
  }).catch(error => {
    vm.$message({
      message: '获取培训详情失败',
      type: 'error',
    });
  });
  Api.getActivityProjectByActivty(vm.id).then(({data}) => {
    if (data.code === 0) {
      formatActivityProject(vm.activityDetail, data.data);
    } else {
      this.$message.error(data.msg);
    }
  }).catch(error => {
    vm.$message({
      message: '获取培训项目详情失败',
      type: 'error',
    });
  });
}

const formatActivityProject = (vm, data) => {
  vm.activityProjectList = data.map(item => {
    if (!item.organizedBy) {
      item.organizedBy = '--';
    }
    if (!item.description) {
      item.description = '--';
    }
    if (!item.descriptionEn) {
      item.descriptionEn = '--';
    }
    if (!item.lecturer) {
      item.lecturer = '--';
    }
    if (item.maxMembers === 0) {
      item.maxMembers = undefined;
    }
    return item;
  });
}

const formatActivityBaseDetail = async (vm, detail, data) => {
  // 培训详情格式化
  detail.id = data.id;
  detail.name = data.name;
  detail.nameEn = data.nameEn;
  // const type = vm.activityTypes.find(item => item.id == data.type);
  // detail.type = type ? type.name : '';
  detail.listPageImage = data.listPageImage;
  detail.image = data.image;
  detail.joinEndTime = data.joinEndTime;
  detail.startTime = data.startTime;
  detail.endTime = data.endTime;
  detail.isOnlyShowDate = data.isOnlyShowDate;
  detail.content = data.content;
  detail.contentEn = data.contentEn;
  if (data.useJoinEndTime == false && data.joinEndBeforeProjectStartHours) {
      detail.joinEndTime = `项目开始前${data.joinEndBeforeProjectStartHours}小时`;
  }
  if (data.useCancelJoinEndTime == false && data.beforeProjectStartHours) {
      detail.showBeforeProject = `项目开始前${data.beforeProjectStartHours}小时`;
  }
  detail.cancelJoinEndTime = data.cancelJoinEndTime;
  detail.place = data.place;
  detail.placeEn = data.placeEn;
  detail.category = data.category;
  detail.status = data.status;
  detail.needApprove = data.needApprove;
  detail.publishedAt = data.publishedAt;
  const statusTypeOption = vm.statusTypeOptions.find((v) => v.value == detail.status)
  detail.statusDesc = statusTypeOption ? statusTypeOption.label : detail.status;
  detail.isPublic = data.isPublic;
  detail.scopeTags = data.activityScopesVOList;
  if (detail.scopeTags && detail.scopeTags.length > 0) {
    await Api.fetchEnrollScopes().then(({data}) =>{
      if (data.code === 0) {
        detail.scopeTags = data.data.filter(item => detail.scopeTags.includes(item.id));
      } else {
        this.$message.error(data.msg);
      }
    });
  } else {
    detail.scopeTags.unshift({
      id: '-1',
      tagName: '所有人',
    });
  }
  if (!data.insertedByName) {
    detail.insertedByName = '--';
  } else {
    // 获取到的insertedByName固定格式为admin:xxx, 需要去掉admin:
    const matchResult = data.insertedByName.match(/(?<=admin:)([\s\S]*)/g);
    detail.insertedByName = !matchResult ? '--': matchResult[0];
  }
  detail.insertedTime = data.insertedTime;
  detail.activityUrl = data.activityUrl;
  detail.multipleProjectsMode = data.multipleProjectsMode;
  detail.multipleProjectsChoseMode = data.multipleProjectsChoseMode;
  detail.showCapacity = data.showCapacity;
  detail.showRemainingPlaces = data.showRemainingPlaces;
  detail.supportQueue = data.supportQueue;
  detail.queueEndBeforeProjectStartHours = `项目开始前${data.queueEndBeforeProjectStartHours}小时`;
  detail.organizedBy = !data.organizedBy ? '--' : data.organizedBy;
  if (data.multipleProjectsChoseMode) {
    detail.enrollmentCount = parseInt(data.maxEnrollProjects) ? (data.minEnrollProjects + '至' + data.maxEnrollProjects + '项') : ('至少' + data.minEnrollProjects + '项');
  } else {
    detail.enrollmentCount = '1项';
  }
  detail.projectGroups = data.projectGroups;
}

export default {
  components: {
    SensitiveData,
  },
  data() {
    return {
      messageToPullOffActivity: '',
      departmentOptions: [],
      activityStatus,
      statusTypeOptions,
      approveStatusOptions,
      employeeApplyStatusTypeOptions,
      activityPendingEnrollmentListTableOption,
      id: 0,
      activeName: "detail",
      activityPublishDialogVisible: false,
      isActivityPublishNotice: false,
      manualDialogVisible: false,
      qrCodeDialogTitle:"二维码",
      qrCodeValue: "",
      qrCodeSize: 300,
      genderValues: {
        0: '女',
        1: '男',
      },
      activityDetail:{
        id: undefined,
        name: "",
        projectGroups:[],
        activityProjectList: [],
        activityEnrollmentList: [],
      },
      currentCheckInDateRangList: [],
      delProjectId: undefined,
      delProjectDialogVisible: false,
      delProjectReason: '',
      selectedEnrollmentList: [],
      sendMassMessageDialogVisible: false,
      activeMassMessageType: 'text',
      massMessageTextContent: '',
      massMessageImageUrl: '',
      isToActivityAllUser: false,
      isSafe: false,
      memberExportLoading: false,
      memberExportName: "导出报名记录",
      checkinExportLoading: false,
      checkinExportName: "导出签到",
      rejectEnrollmentDialogVisible: false,
      rejectEnrollmentReason: '',
      delEnrollmentId: undefined,
      delEnrollmentDialogVisible: false,
      delEnrollmentReason: '',
      activityPullOffDialogVisible: false,
      isActivityPullOffNoticeInvitedUser: false,
      isActivityPullOffNoticeEnrolledUser: false,
      checkInTimeDialogVisible: false,
      search: {
        current: 1,
        size: 10,
        sortField: "",
        sortPolicy: "",
        searchValue: "",
        department: '',
        unionId: '',
        enrollStatus: '',
        auditStatus: '',
        checkInTimes: "",
        tagId: undefined,
        projectId: undefined,
        groupId: undefined,
        status: "APPROVED",
        organizationalUnitName: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableLoading: false,
      activityApprovedEnrollmentListTableOption: activityApprovedEnrollmentListTableOption,
      activityTypes: [],
      currentCheckinTimeList: [],
      projectCheckinMiniprogramQrcodeDialogVisible: false,
      projectCheckinMiniProgramQrcodeUrl: '',
      inviteMemberProjectName: '',
      inviteMemberProjectId: undefined,
      inviteMemberDialogVisible: false,
      inviteMemberUnionIds: '',
    }
  },
  watch: {
    $route() {
      this.id = this.$route.params.id;
      initDetail(this);
      this.loadDepartmentOptions();
      this.getActivityEnrollmentList(this);
    },
  },
  created() {
    if (this.$route.query.showTab && this.$route.query.showTab  == 'activityProject' ) {
      this.activeName = this.$route.query.showTab 
    }
  },
  async mounted() {
    this.id = this.$route.params.id;
    initDetail(this);
    this.loadDepartmentOptions();
    this.getActivityEnrollmentList(this);
    const response = await this.requestWrapper(Api.getAllActivityTypes);
    if (response.code === 0) {
      this.activityTypes = response.data;
    } else {
      this.$message.error(response.msg);
    }
    
  },
  computed: {
    ...mapGetters(['permissions']),
    activityProjectsTableOption() {
      return this.activityDetail.supportQueue ? supportQueueActivityProjectsTableOption : activityProjectsTableOption;
    }
  },
  methods: {
    dateFormat(datetime) {
      return formatDate('YYYY-mm-dd HH:MM', new Date(datetime));
    },
    onTabShow(tab) {
      switch (tab.name) {
        case 'detail':
          if (this.$route.query.showTab) {
            let newQuery = JSON.parse(JSON.stringify(this.$route.query))
            delete newQuery.showTab
            this.$router.replace({ query: newQuery })
          }
          break;
        case 'enrollment':
          break;
        case 'activityProject':
          break;
      }
    },
    openQrCodeDialog(url, title) {
      this.manualDialogVisible = true;
      this.qrCodeDialogTitle=title;
      this.qrCodeValue = url;
    },
    closeQrCodeDialog() {
      this.manualDialogVisible = false;
      this.qrCodeDialogTitle= '二维码';
      this.qrCodeValue = '';
    },
    changeQrCodeSize(size) {
      this.qrCodeSize = size;
    },
    downloadQrCode() {
      const imgUrl = document.getElementById('activity-qr-code').firstElementChild.src;
      if (window.navigator.msSaveOrOpenBlob) {
        let bstr = atob(imgUrl.split(",")[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let blob = new Blob([u8arr]);
        window.navigator.msSaveOrOpenBlob(blob, "qrcode" + "." + "png");
      } else {
        let a = document.createElement("a");
        a.href = imgUrl;
        a.setAttribute("download", "qrcode");
        a.click();
      }
    },
    searchChange() {
      this.activityDetail.activityEnrollmentList=[];
      this.getActivityEnrollmentList(this);
    },
    searchReset() {
      this.search.searchValue = "";
      this.search.department = "";
      this.search.checkInTimes = "";
      this.search.tagId = undefined;
      this.search.projectId = undefined;
      this.search.groupId = undefined;
      this.search.enrollStatus = "";
      this.search.auditStatus = "";
      this.search.unionId = '';
      this.search.organizationalUnitName = '';
      this.activityDetail.activityEnrollmentList=[];
      this.getActivityEnrollmentList(this);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.search.current = val;
      this.activityDetail.activityEnrollmentList=[];
      this.getActivityEnrollmentList(this);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.search.size = val;
      this.activityDetail.activityEnrollmentList=[];
      this.getActivityEnrollmentList(this);
    },
    handleSortChange(val) {
        if (val.prop == "createTime") {
        this.search.sortField = "inserted_time";
      } else {
        this.search.sortField = "";
      }
      // 检查排序方式
      if (val.order == 'ascending') {
        this.search.sortPolicy = "asc";
      } else if (val.order == 'descending') {
        this.search.sortPolicy = "desc";
      } else {
        this.search.sortPolicy = "";
      }
      this.activityDetail.activityEnrollmentList=[];
      this.getActivityEnrollmentList(this);
    },
    previewCheckinMiniProgramQrcode(projectId) {
      const messageRef = this.$message({
        message: "获取项目签到小程序二维码中...",
        type: "warning",
        duration: 0,
      });
      setTimeout(() => {
        Api.getActivityProjectCheckinMiniProgramCode(projectId).then((response) =>{
          messageRef.close();
          this.projectCheckinMiniProgramQrcodeUrl = response.data.data;
          this.projectCheckinMiniprogramQrcodeDialogVisible = true;
        });
      }, 1000);
    },
    handleInviteMember(row, index) {
      this.inviteMemberProjectName = row.name;
      this.inviteMemberProjectId = row.id;
      this.inviteMemberDialogVisible = true;
    },
    handleSendCourseReminder(row, index) {
      this.$confirm('确定要发送课程提醒吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api.sendCourseReminder(row.id).then(response => {
          if (response.data.code === 0) {
            initDetail(this);
            this.getActivityEnrollmentList(this);
            this.$message.success("发送成功");
          } else {
            this.$message.error(response.data.msg);
          }
        })
      }).catch(function (err) {
      })
    },
    handleCancelInviteMember() {
      this.inviteMemberUnionIds = '';
      this.inviteMemberDialogVisible = false;
    },
    handleConfirmInviteMember() {
      if (this.inviteMemberUnionIds === '' || this.inviteMemberUnionIds.trim() === '') {
        return this.$message.error('员工号不能为空');
      }
      Api.inviteMember(this.inviteMemberProjectId, this.inviteMemberUnionIds).then(response => {
        if (response.data.code === 0) {
          initDetail(this);
          this.getActivityEnrollmentList(this);
          this.$message.success("邀请成功");
          this.inviteMemberUnionIds = '';
          this.inviteMemberDialogVisible = false;
        } else {
          this.inviteMemberUnionIds = '';
          this.$message.error(response.data.msg);
        }
      })
    },
    loadDepartmentOptions() {
      fetchDepartmentOptions().then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.departmentOptions = response.data.data;
        }
      });
    },
    generateEnrollmentListSearchParams() {
      let params = {
        current: this.search.current,
        size: this.search.size,
        activityId: this.id,
      }
      if (this.search.searchValue != "" && this.search.searchValue.trim() != "") {
        params.searchValue = this.search.searchValue;
      }
      if (this.search.department != "" && this.search.department.trim() != "") {
        params.department = this.search.department;
      }
      if (this.search.unionId != "" && this.search.unionId.trim() != "") {
        params.unionId = this.search.unionId;
      }
      if (this.search.organizationalUnitName != "" && this.search.organizationalUnitName.trim() != "") {
        params.organizationalUnitName = this.search.organizationalUnitName;
      }
      if (this.search.checkInTimes != "" && this.search.checkInTimes.trim() != "") {
        params.checkInTimes = this.search.checkInTimes;
      }
      if (this.search.tagId && this.search.tagId != -1) {
        params.tagId = this.search.tagId;
      }
      if (this.search.projectId) {
        params.projectId = this.search.projectId;
      }
      if (this.search.groupId) {
        params.groupId = this.search.groupId;
      }
      if (this.search.status != "" && this.search.status.trim() != "") {
        params.isAudited = this.search.status === 'APPROVED';
      }
      if (this.search.enrollStatus) {
        params.enrollStatus = this.search.enrollStatus;
      }
      if (this.search.auditStatus) {
        params.auditStatus = this.search.auditStatus;
      }
      if (this.search.sortField != "" && this.search.sortField.trim() != "") {
        params.sortField = this.search.sortField;
      } else {
        params.sortField = "inserted_time";
        this.search.sortField = params.sortField;
      }
      if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "") {
        params.sortPolicy = this.search.sortPolicy;
      } else {
        params.sortPolicy = "desc"
        this.search.sortPolicy = params.sortPolicy;
      }
      return params;
    },
    getActivityEnrollmentList(vm) {
      let params = this.generateEnrollmentListSearchParams();
      this.tableLoading = true;
      Api.fetchMcActivityEnrollmentList(params).then(({data}) => {
        if (data.code === 0) {
          this.formatActivityBaseDetail(vm, data.data.records);
          this.page.total = data.data.total;
          this.tableLoading= false;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    formatActivityBaseDetail(vm, data) {
      let list = [];
      data.forEach((item) => {
        if (!item.currentCheckinTimes || item.currentCheckinTimes === null) {
          item.currentCheckinTimes = 0;
        }

        if (!item.totalCheckinTimes ||item.totalCheckinTimes === null || item.totalCheckinTimes === '0') {
          item.totalCheckinTimes = ' - ';
        }
        item.gender = this.genderValues[item.gender];
        item.checkin = item.currentCheckinTimes + '/' + item.totalCheckinTimes;
        item.department = !item.department ? '' : item.department.substring(item.department.indexOf(' '));
        list.push(item);
      });
      vm.activityDetail.activityEnrollmentList = list;
    },
    getProjectGroupName(groupId) {
      const group = this.activityDetail.projectGroups.find(group => group.id === groupId);
      if (group) {
        return group.name;
      }
      return null;
    },
    toEditProjectGroup() {
      this.$router.push({ path: `/app/activity/edit/${this.id}?isShowProjectGroups=true` })
    },
    handleSelectionChange(list) {
      this.selectedEnrollmentList = list;
    },
    handleViewProjectCheckinDateRangeList(checkInDateRange) {
      this.checkInDateRangeDialogVisible = true;
      this.currentCheckInDateRangList = checkInDateRange;
    },
    handleCheckInDateRangeDialogClose() {
      this.currentCheckInDateRangList = [];
    },
    getQuestionnaireDetail(questionnaireId) {
      const routeData =this.$router.resolve({
        path: `/app/questionnaire/detail/${questionnaireId}`,
      });
      window.open(routeData.href,'_blank');
    },
    handleEnrollmentDel(enrollmentId) {
      this.delEnrollmentId = enrollmentId;
      this.delEnrollmentDialogVisible = true;
    },
    generateEnrollmentOperationParams() {
      let params = this.generateEnrollmentListSearchParams();
      if (this.selectedEnrollmentList.length > 0) {
        params.enrollmentIds = this.selectedEnrollmentList.map(item => item.id).join(',');
      }
      return params;
    },
    handleEnrollmentCheckinExport() {
      if (this.search.current === 1 && this.activityDetail.activityEnrollmentList.length === 0) {
        return this.$message({
          message: "导出失败，没有可导出的信息",
          type: "warning",
        });
      }
      Api.exportActivityEnrollmentCheckIn(this.generateEnrollmentOperationParams()).then(({data}) => {
        if (data.code === 0) {
          this.checkinExportLoading = true;
          this.checkinExportName = "导出中...";
          exporting(data.data, this.checkinExportCallback);
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    handleEnrollmentMemberExport() {
      if (this.search.current === 1 && this.activityDetail.activityEnrollmentList.length === 0) {
        return this.$message({
          message: "导出失败，没有可导出的信息",
          type: "warning",
        })
      }
      Api.exportActivityEnrollmentMember(this.generateEnrollmentOperationParams()).then(({data}) => {
        if (data.code === 0) {
          this.memberExportLoading = true;
          this.memberExportName = "导出中...";
          exporting(data.data, this.memberExportCallback);
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    checkinExportCallback(result) {
      this.checkinExportLoading = false;
      this.checkinExportName = "导出签到";
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success',
        });
      }
    },
    memberExportCallback(result) {
      this.memberExportLoading = false;
      this.memberExportName = "导出报名记录";
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success'
        });
      }
    },
    openPublishDialog() {
      this.activityPublishDialogVisible = true;
    },
    handlePublishActivity() {
      const msgRef = this.$message({
        type: 'warning',
        message: '正在上架培训 ...',
        duration: 0,
      });
      Api.publishActivity(this.id, { isSendMessage: this.isActivityPublishNotice }).then(({data}) => {
         if (data.code === 0) {
          this.activityPublishDialogVisible = false;
          this.$message.success("成功上架培训");
          initDetail(this);
        } else {
          this.$message.error(data.msg);
        }
      }).finally(() => {
        msgRef.close();
      })
    },
    handleApproveEnrollment() {
      if (this.selectedEnrollmentList.length === 0) {
        return this.$message.warning("请至少勾选一个员工");
      } else {
        Api.approveActivityEnrollment(this.generateEnrollmentOperationParams()).then(({ data }) => {
          if (data.code === 0) {
            this.$message.success("批准成功");
            this.searchChange();
          } else {
            this.$message.error(data.msg);
          }
        });
      }
    },
    openRejectEnrollmentDialog() {
      if (this.selectedEnrollmentList.length === 0) {
        return this.$message.warning("请至少勾选一个员工");
      } else {
        this.rejectEnrollmentDialogVisible = true;
      }
    },
    handleRejectEnrollment() {
      if (this.selectedEnrollmentList.length === 0) {
        return this.$message.warning("请至少勾选一个员工");
      } else {
        let params = this.generateEnrollmentOperationParams();
        if (this.rejectEnrollmentReason === '' || this.rejectEnrollmentReason.trim() === '') {
          this.$message.error('原因不能为空');
          return;
        }
        params.reason = this.rejectEnrollmentReason;
        Api.rejectActivityEnrollment(params).then(({ data }) => {
          if (data.code === 0) {
            this.rejectEnrollmentDialogVisible = false;
            this.$message.success("拒绝参与成功");
            this.searchChange();
          } else {
            this.$message.error(data.msg);
          }
        })
      }
    },
    openSendMassMessageDialog(isToActivityAllUser) {
      if (!isToActivityAllUser) {
        if (this.selectedEnrollmentList.length === 0) {
          return this.$message.warning('请至少勾选一个用户');
        }
      }
      this.isToActivityAllUser = isToActivityAllUser;
      this.sendMassMessageDialogVisible = true;
    },
    handleMassMessageImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.massMessageImageUrl = list[0].contentUrl;
        }
      }, 1);
    },
    handleSendMassMessage() {
      let params = {};
      params.isTextMessage = this.activeMassMessageType === 'text';
      if (this.massMessageTextContent === '' || this.massMessageTextContent.trim() === '') {
        if (params.isTextMessage) {
          return this.$message.error('请填写短信内容');
        }
      }
      if (this.massMessageImageUrl === '' || this.massMessageImageUrl.trim() === '') {
        if (!params.isTextMessage) {
          return this.$message.error('请选择图片');
        }
      }
      params.activityId = this.id;
      params.memberIds = this.selectedEnrollmentList.map(enrollment => enrollment.memberId);
      params.content = this.massMessageTextContent;
      params.fileUrl = this.massMessageImageUrl;
      params.isToActivityAllUser = this.isToActivityAllUser;
      params.isSafe = this.isSafe;
      const msgRef = this.$message({
        type: 'warning',
        message: '正在发送信息 ...',
        duration: 0,
      });
      Api.sendMassMessage(params).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success('群发短信成功');
          this.massMessageTextContent = '';
          this.massMessageImageUrl = '';
          this.activeMassMessageType = 'text';
          this.isSafe = false;
          this.sendMassMessageDialogVisible = false;
        } else {
          this.$message.error(data.msg);
        }
      }).finally(() => {
        msgRef.close();
      })
    },
    handleDelEnrollment() {
      if (this.delEnrollmentReason === '' || this.delEnrollmentReason.trim() === '') {
        return this.$message.error('请填写原因');
      }
      Api.deleteActivityEnrollment(this.delEnrollmentId, this.delEnrollmentReason).then(({data}) => {
        if (data.code === 0) {
          this.$message.success('删除成功');
          this.delEnrollmentDialogVisible = false;
          this.delEnrollmentId = undefined;
          this.delEnrollmentReason = '';
          this.getActivityEnrollmentList(this);
        } else {
          this.$message.error(data.msg);
        }
      })
    },
    openPullOffDialog() {
      this.activityPullOffDialogVisible = true;
    },
    handlePullOffActivity() {
      if (this.messageToPullOffActivity === '' || this.messageToPullOffActivity.trim() === '') {
        this.$message.error('下架原因不能为空');
        return;
      }
       const msgRef = this.$message({
        type: 'warning',
        message: '正在下架培训 ...',
        duration: 0,
      });
      Api.pullDownActivity(
        this.id, 
        { 
          isSendMessageToInvitedUser: this.isActivityPullOffNoticeInvitedUser,
          isSendMessageToEnrolledUser: this.isActivityPullOffNoticeEnrolledUser,
          reason: this.messageToPullOffActivity
        }
      ).then(({data}) => {
         if (data.code === 0) {
            this.$message.success("成功下架培训");
            this.messageToPullOffActivity = '';
            initDetail(this);
          } else {
            this.$message.error(data.msg);
          }
      }).finally(() => {
        msgRef.close();
      });
      this.activityPullOffDialogVisible = false;
    },
    showCheckInTimeDialog(row) {
      this.currentCheckinTimeList = [];
      if (row.checkinTimeList) {
        this.currentCheckinTimeList = row.checkinTimeList.split(',');
      }
      this.checkInTimeDialogVisible = true;
    },
    // 关闭【优先排队】功能
    // handleEnrollmentPriorityQueuing(row) {
    //   Api.enrollmentPriorityQueuing(row.id).then(({data}) => {
    //      if (data.code === 0) {
    //       this.$message.success("设置优先排队成功， 当有名额剩余，此报名记录将优先报名");
    //       initDetail(this);
    //     } else {
    //       this.$message.error(data.msg);
    //     }
    //   });
    // }
  }
}
</script>

<style lang="scss" scoped>
.activity-detail {
  .activity-detail-item {
    font-size: 16px;
    margin: 10px 0;
  }
}
.activity-cover-image {
  display: flex;
  width: fit-content;
  cursor: pointer;
  img {
    width: 200px;
  }
}

.activity-list-page-image {
  display: flex;
  width: fit-content;
  cursor: pointer;
  img {
    width: 100px;
  }
}

.operation {
  text-align: right
}

.dialog-body-row {
  line-height: 36px;
}

.can-click-item{
  color: #1696d7;
  cursor: pointer;
}

.checkin-daterange-dialog-item {
  margin-bottom: 10px;
}

#activity-qr-code {
  display: none;
}
.ju-modal-content {
  display: flex;
	justify-content: center;
}
.size-options {
  width: 120px;
  height: 80px;
  border-radius: 2px;
  color: #71849c;
  display: inline-block;
  background-color: #d7e3f0;
  text-align: center;
  cursor: pointer;

  &:nth-child(1) {
    margin-right: 20px;
  }

  &:nth-child(2) {
    margin-right: 20px;
  }
  .size-content {
    margin-top: 14px;
    .size-types {
      font-size: 18px;
    }
    .size-value {
      font-size: 14px;
    }
  }
}

.option-select {
  background-color: #8aaed9;
  color: 'white';
}

.mass-message-image {
  width: 160px;
  height: 160px;
}

.button-new-activity-project {
  color: #4DA1FF;
  font-size: 11px;
  border: 1px solid #4DA1FF;
  padding: 8px 11px;
  margin-right: 8px;
}

.activity-enrollment-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
}
.divider {
  background-color: #7a869e;
  width: 100%;
  height: 2px;
  margin-bottom: 50px;
}
/deep/ .el-dialog.preview-img-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
</style>
